import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Filter } from 'src/app/core/interfaces/filter.interface';
import { ProductCategory } from 'src/app/core/interfaces/product-category.interface';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ProductCategoryService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient, private router: Router) { }

  getProductCategory(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl + '/ProductCategory'}` + '/' + id);
  }

  listProductCategories(PageNumber = 1, PageSize = 10, Term = '', AdvancedFilter?: Filter, orderBy?: any): Observable<any> {
    const params = {
      PageNumber,
      PageSize,
      Term,
      AdvancedFilter: AdvancedFilter,
      orderBy: orderBy ? [orderBy] : undefined,
    };

    return this.http.post(`${this.baseUrl + '/ProductCategory/list'}`, params);
  }

  createProductCategory(data: ProductCategory): Observable<any> {
    return this.http.post(`${this.baseUrl + '/ProductCategory'}`, data);
  }

  updateProductCategory(data: ProductCategory): Observable<any> {
    return this.http.put(`${this.baseUrl + '/ProductCategory'}`, data);
  }

  deleteProductCategory(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl + '/ProductCategory'}` + '/' + id);
  }
}
